import { render, staticRenderFns } from "./FullscreenArrow.vue?vue&type=template&id=4baf1a75&scoped=true&"
import script from "./FullscreenArrow.vue?vue&type=script&lang=ts&"
export * from "./FullscreenArrow.vue?vue&type=script&lang=ts&"
import style0 from "./FullscreenArrow.vue?vue&type=style&index=0&id=4baf1a75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf1a75",
  null
  
)

export default component.exports